import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String, skipRestore: Boolean }

  connect() {
    this.storageKey = this.keyValue || "form_persistence"

    if (!this.skipRestoreValue) this.restore()

    this._save = this.save.bind(this)
    this._handleSubmitEnd = this.handleSubmitEnd.bind(this)

    this.element.addEventListener("input", this._save)
    this.element.addEventListener("change", this._save)
    document.addEventListener("turbo:submit-end", this._handleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("input", this._save)
    this.element.removeEventListener("change", this._save)
    document.removeEventListener("turbo:submit-end", this._handleSubmitEnd)
  }

  save() {
    const data = {}
    for (const el of this.element.elements) {
      if (!el.name || el.type === "file" || el.type === "hidden") continue
      if (el.type === "checkbox" || el.type === "radio") {
        if (!data[el.name]) data[el.name] = []
        if (el.checked) data[el.name].push(el.value)
      } else {
        data[el.name] = el.value
      }
    }
    localStorage.setItem(this.storageKey, JSON.stringify(data))
  }

  restore() {
    const stored = localStorage.getItem(this.storageKey)
    if (!stored) return

    let data
    try { data = JSON.parse(stored) } catch { return }

    for (const el of this.element.elements) {
      if (!el.name || el.type === "file" || el.type === "hidden") continue
      const saved = data[el.name]
      if (saved === undefined) continue

      if (el.type === "checkbox" || el.type === "radio") {
        el.checked = Array.isArray(saved) && saved.includes(el.value)
      } else {
        el.value = saved
      }
    }
  }

  handleSubmitEnd(event) {
    if (event.detail.success && event.detail.formSubmission?.formElement === this.element) {
      localStorage.removeItem(this.storageKey)
    }
  }
}
